export const markPerformance = (message: string): void => {
  const scope = '[mx-root]';
  if (window.performance) {
    window.performance.mark(`${scope} ${message}`);
  }
};
